import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { version } from './version';

export const environment = {
  production: false,
  context: 'Customer - CI',
  vendor: false,
  tracking: true,
  version: version,
  // Point d'accès COM+ (proxy) utilisé par l'écran d'administration COM+.
  dotComPlusURL: '/api/dotcomplus/staging',
  castorama: {
    msalAuthConf: {},
    webServices: {
      baseUrl: 'https://staging.api.kingfisher.com',
      environmentUrl: '/hft',
      apiVersion: 'v2',
      tenant: 'CAFR',
      clientId: 'kingfisher-staging-xXEurXfP4IxuwGSfoiRIWK7s9Ezq1y8HJXdCziYE',
      clientSecret: 'fe4aaa08d626b1cb11948f43f2d0ecedeadacaf753a204e2d1a10b1f6d9ba6b9',
      beginUsername: 'HFT-',
    },
    loyalty: {
      fidelityLearnMoreFreeCardURL: 'https://www.castorama.fr/avantages-carte-castorama/la-carte-de-fidelite-castorama',
      fidelityLearnMorePremiumCardURL:
        'https://www.castorama.fr/avantages-carte-castorama/la-carte-de-fidelite-castorama',
    },
    productApi: {
      searchUrl: undefined,
      token: undefined,
    },
  },
  byMe: {
    apiHostName: 'staging-platform.enterprise.by.me',
    webServiceURL: 'https://staging-platform.enterprise.by.me',
    tokenURL: 'https://lx4e170x22.execute-api.eu-west-1.amazonaws.com/main/',
    comPlusURL: 'https://hftcafr-afa.aws.ghanp.kfplc.com/agent-front/jsp/agent',
    kitchen: {
      isCustomerOpened: true,
      appURL: '/Kitchen/',
      origin: 'https://staging-kitchen.enterprise.by.me',
      distribID: 'CastoramaGH2020',
      storeAppointmentLink: 'https://devices.minutpass.com/iframe.html?header=1&context=CASTORAMA&configuration=3022',
      onlineAppointmentLink:
        'https://devices.minutpass.com/iframe.html?header=1&context=CASTORAMA&configuration=3023&placeId=2838',
    },
    storage: {
      isCustomerOpened: true,
      appURL: '/Kitchen/',
      datas: 'datas/storage-inspiration.staging.json',
      origin: 'https://staging-kitchen.enterprise.by.me',
      distribID: 'ATOMIA',
      storeAppointmentLink: 'https://devices.minutpass.com/iframe.html?header=1&context=CASTORAMA&configuration=3048',
      onlineAppointmentLink:
        'https://devices.minutpass.com/iframe.html?header=1&context=CASTORAMA&configuration=3049&placeId=2838',
    },
    bathroom: {
      isCustomerOpened: true,
      appURL: '/Bathroom/',
      origin: 'https://staging-bathroom.enterprise.by.me',
      distribID: 'CASTOBATHROOM',
      storeAppointmentLink: '',
      onlineAppointmentLink: '',
    },
  },
  configurators2d: {
    baseApi: '#{backend_url}#',
    global: {
      administrators: {
        apiName: 'administrators/',
      },
      debug: {
        autoSelectStore: false,
        fakeCustomer: false,
        forceAdmin: false,
        data: {
          store: '1410',
          customer: {
            id: 'SQ_3001836829',
            kfId: 'fake',
            lastname: 'Simphonis',
            firstname: 'Test',
            email: 'test@simphonis.com',
          },
        },
      },
    },
    applications: {
      closetDoors: {
        apiName: 'closetdoors/',
        gtmRef: 'portes-de-placard',
        routeUrl: 'portesdeplacard',
        distribID: CONFIG_CONTEXT.CLOSET_DOORS,
        appCode: 'A',
        isCustomerOpened: true,
        children: [
          {
            apiName: 'closetdoors/standard/',
            routeUrl: 'a_mesure',
            distribID: CONFIG_CONTEXT.CLOSET_DOORS_STANDARD,
            appCode: 'A1',
            isCustomerOpened: true,
          },
          {
            apiName: 'closetdoors/customMade/',
            routeUrl: 'sur_mesure',
            distribID: CONFIG_CONTEXT.CLOSET_DOORS_CUSTOM,
            appCode: 'A2',
            isCustomerOpened: true,
          },
        ],
        internalConfig: true,
        configWithPreview: true,
        savePdf: false,
      },
      fence: {
        apiName: 'fence/',
        gtmRef: 'cloture',
        routeUrl: 'cloture',
        distribID: CONFIG_CONTEXT.FENCE,
        appCode: 'F',
        internalConfig: true,
        isCustomerOpened: true,
        configWithPreview: true,
        savePdf: false,
      },
      deckingBoards: {
        apiName: 'deckingboards/',
        gtmRef: 'terrasse',
        routeUrl: 'terrasse',
        distribID: CONFIG_CONTEXT.DECKING_BOARDS,
        appCode: 'D',
        internalConfig: true,
        isCustomerOpened: true,
        configWithPreview: true,
        savePdf: false,
      },
      carpentry: {
        apiName: 'carpentry/',
        gtmRef: 'menuiserie',
        routeUrl: 'menuiserie',
        distribID: CONFIG_CONTEXT.CARPENTRY,
        appCode: 'C',
        internalConfig: false,
        isCustomerOpened: false,
        configWithPreview: false,
        savePdf: false,
        spidCasto: 'https://spid-casto.fr',
        env: 'projet',
      },
    },
  },
  sentry: {
    dsn: '#{sentry_dsn}#',
    tunnel: '#{sentry_tunnel}#',
    environment: '#{sentry_environment}#',
    debug: false,
    release: version,
  },
  installationSpecifics: {
    bathroomV2: {
      disableInstallation: false,
    },
    // Pose vendeur uniquement : clé déclarée pour la compilation, sans valeur côté customer.
    bathroomHbm: {
      disableInstallation: undefined,
    },
    carpentry: {
      disableInstallation: true,
    },
  },
  links: {
    termsOfUseUrl:
      'https://media.castorama.fr/is/content/KingfisherDigital/EPHC-PDF-CGU-JUILLET-01~5207b0b2ba93ad3b3287b9b9ea6a13563bd5d614pdf',
    termsOfSaleUrl:
      'https://media.castorama.fr/is/content/KingfisherDigital/EPHC-PDF-CGU-JUILLET-01~5207b0b2ba93ad3b3287b9b9ea6a13563bd5d614pdf',
    basketUrl: 'https://www.h-tier.castorama.fr/basket',
  },
};
